import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type pmliCredType = CarrierLogisticsCredType
export const pmliDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const pmli: CarrierDef<pmliCredType> = {
  name: 'Pace Motor Lines',
  scac: 'pmli',
  ...carrierLogistics,
  engineLayers: ['documents'],
  documentTypes: pmliDocumentTypes,
}
